import { FC, useEffect, useState } from "react";
import {
  AutocompleteInput,
  ReferenceInput,
  required,
  useDataProvider,
} from "react-admin";
import { useField } from "react-final-form";

interface RouteInput {
  isDisable?: boolean;
}

const RouteInput: FC<RouteInput> = ({ isDisable }) => {
  const [busSchedulePlan, setBusSchedulePlan] = useState<IBusSchedulePlans>();

  const provider = useDataProvider();

  const {
    input: { value },
  } = useField("busScheduleId");

  useEffect(() => {
    if (value !== "") {
      getBusSchedulePlans(value).then((result) => {
        setBusSchedulePlan(result as IBusSchedulePlans);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const getBusSchedulePlans = async (busScheduleId: Number) => {
    return await provider
      .getList("busSchedulePlans", {
        filter: { BusScheduleId: busScheduleId },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Id",
          order: "ASC",
        },
      })
      .then((result) => {
        return result.data[0];
      });
  };

  return (
    <ReferenceInput
      label="Select Route"
      source="routeId"
      reference="routes"
      filter={{
        RoutePlanId: busSchedulePlan
          ? Number(busSchedulePlan.routePlan?.id)
          : 0,
      }}
      sort={{ field: "name", order: "ASC" }}
      disabled={isDisable}
      perPage={9999}
      validate={required()}
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  );
};

export default RouteInput;
